var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("store_picker_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('store_picker_page.form_desc'))
    }
  }), _vm.getModuleConfig('branch_picker_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('branch_picker_page.content'))
    }
  }) : _vm._e(), _vm._l(_vm.options, function (option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "col-12 px-2"
    }, [_c('SharedRadio', {
      attrs: {
        "id": "proxy-".concat(idx),
        "value": option.value,
        "name": "proxy"
      },
      model: {
        value: _vm.channel,
        callback: function callback($$v) {
          _vm.channel = $$v;
        },
        expression: "channel"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
  }), _vm.getModuleConfig('store_picker_page.button_text') || _vm.getModuleConfig('store_picker_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.channel || _vm.showLoading
    },
    on: {
      "click": _vm.bindStore
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("store_picker_page.button_text")))]), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('store_picker_page.cancel_button_text'),
      "button-url": _vm.getModuleConfig('store_picker_page.cancel_button_url'),
      "type": _vm.getModuleConfig('store_picker_page.cancel_button_action'),
      "disabled": _vm.showLoading
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }